import React, { useState, useEffect, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import { Form, Button, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { createProduct } from "../actions/productActions";
import Loader from "../components/Loader";
import Message from "../components/Message";
import Navbar from "../components/Navbar";
import { PRODUCT_CREATE_RESET } from "../constants/productConstants";
import FormContainer from "../components/FormContainer";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "../components/Map.css";
import { IoArrowBackOutline } from "react-icons/io5";

const ProductCreateScreen = ({ history }) => {
  const [gensetNumber, setGensetNumber] = useState();
  const [getsetStatus, setGetsetStatus] = useState("OFF");
  const [engineSpeedRPM, setEngineSpeedRPM] = useState(0);
  const [onRelayTime, setOnRelayTime] = useState(2);
  const [offRelayTime, setOffRelayTime] = useState(2);
  const [fuelSensorType, setFuelSensorType] = useState(1);
  const [engineSpeedRPMMin, setEngineSpeedRPMMin] = useState(0);
  const [engineSpeedRPMMax, setEngineSpeedRPMMax] = useState(0);
  const [engineCoolantTemp, setEngineCoolantTemp] = useState(0);
  const [engineCoolantTempMin, setEngineCoolantTempMin] = useState(0);
  const [engineCoolantTempMax, setEngineCoolantTempMax] = useState(100);
  const [engineOilPressure, setEngineOilPressure] = useState(0);
  const [engineOilPressureMin, setEngineOilPressureMin] = useState(0);
  const [engineOilPressureMax, setEngineOilPressureMax] = useState(0);
  const [oilTemp, setOilTemp] = useState(0);
  const [oilTempMin, setOilTempMin] = useState(0);
  const [oilTempMax, setOilTempMax] = useState(0);
  const [powerFactor, setPowerFactor] = useState(0);
  const [powerFactorMin, setPowerFactorMin] = useState(0.75);
  const [powerFactorMax, setPowerFactorMax] = useState(0);
  const [powerKW, setPowerKW] = useState(0);
  const [powerKWMin, setPowerKWMin] = useState(0);
  const [powerKWMax, setPowerKWMax] = useState(0);
  const [kwh, setKwh] = useState(0);
  const [kwhMin, setKwhMin] = useState(0);
  const [kwhMax, setKwhMax] = useState(23);
  const [batteryVoltage, setBatteryVoltage] = useState(0);
  const [batteryVoltageMin, setBatteryVoltageMin] = useState(11);
  const [batteryVoltageMax, setBatteryVoltageMax] = useState(0);
  const [totalRunningHours, setTotalRunningHours] = useState(0);
  const [fuelLevel, setFuelLevel] = useState(0);
  const [fuelLevelMin, setFuelLevelMin] = useState(50);
  const [fuelLevelMax, setFuelLevelMax] = useState(0);
  const [frequency, setFrequency] = useState(0);
  const [frequencyMin, setFrequencyMin] = useState(45);
  const [frequencyMax, setFrequencyMax] = useState(55);
  const [voltage, setVoltage] = useState(0);
  const [voltageMin, setVoltageMin] = useState(190);
  const [voltageMax, setVoltageMax] = useState(245);
  const [current, setCurrent] = useState(0);
  const [currentMin, setCurrentMin] = useState(0);
  const [currentMax, setCurrentMax] = useState(100);
  const [servicedueDate, setServicedueDate] = useState({});
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [serviceHours, setServiceHours] = useState(400)
  const [remainingHours, setRemainingHours] = useState(0)
  const [fuelVolume, setFuelVolume] = useState(0)
  const center = {
    lat: 30.72980013,
    lng: 76.70461848,
  };
  const [draggable, setDraggable] = useState(true);
  const [position, setPosition] = useState(center);

  //   const { register, handleSubmit } = useForm();

  const dispatch = useDispatch();
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const productDetails = useSelector((state) => state.productDetails);
  const { loading, error, product } = productDetails;
  const productCreate = useSelector((state) => state.productCreate);
  const {
    loading: loadingCreate,
    error: errorCreate,
    success: successCreate,
    product: createdProduct,
  } = productCreate;

  useEffect(() => {
    dispatch({ type: PRODUCT_CREATE_RESET });
    
    if (successCreate) {
      dispatch({ type: PRODUCT_CREATE_RESET });
      history.push("/admin/productlist");
      // dispatch(listProducts());
    }
  }, [dispatch, history, product, successCreate, createdProduct]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      gensetNumber,
      getsetStatus,
      onRelayTime,
      offRelayTime,
      fuelSensorType,
      engineSpeedRPM,
      engineSpeedRPMMin,
      engineSpeedRPMMax,
      engineCoolantTemp,
      engineCoolantTempMin,
      engineCoolantTempMax,
      engineOilPressure,
      engineOilPressureMin,
      engineOilPressureMax,
      oilTemp,
      oilTempMin,
      oilTempMax,
      powerFactor,
      powerFactorMin,
      powerFactorMax,
      powerKW,
      powerKWMin,
      powerKWMax,
      kwh,
      kwhMin,
      kwhMax,
      runningLeftTime: totalRunningHours,
      batteryVoltage,
      batteryVoltageMin,
      batteryVoltageMax,
      fuelLevel,
      fuelLevelMin,
      fuelLevelMax,
      frequency,
      frequencyMin,
      frequencyMax,
      voltage,
      voltageMin,
      voltageMax,
      current,
      currentMin,
      currentMax,
      servicedueDate: new Date(servicedueDate).valueOf(),
      latitude: position.lat,
      longitude: position.lng,
      serviceHours,
      remainingHours,
      fuelVolume
    };
    dispatch(createProduct(data));
  };
  const markerRef = useRef(null);
  const eventHandlers = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current;
        if (marker != null) {
          setPosition(marker.getLatLng());
        }
      },
    }),
    []
  );
  const toggleDraggable = React.useCallback(() => {
    setDraggable((d) => !d);
  }, []);

  return (
    <>
      <Navbar />
      <br />
      <br />
      <br />
      <br />
      <div className="tw-mx-6 tw-font-nunito">
        <Link
          to="/admin/productlist"
          className="tw-flex tw-justify-center tw-items-center tw-w-12 tw-h-12 tw-ml-1 tw-mt-5 tw-rounded-full hover:tw-bg-gray-200"
        >
          <IoArrowBackOutline className="tw-text-blueGray-400 tw-text-4xl" />
        </Link>
        {loadingCreate && <Loader />}
        {errorCreate && <Message variant="danger">{errorCreate}</Message>}
        <FormContainer>
          <h3 className="tw-font-nunito sm:tw-text-3xl tw-text-2xl tw-font-bold tw-text-center tw-my-4">
            Create Genset Details
          </h3>
          <div className="tw-mt-8">
            <Row>
              <Col md={12}>
                {loading ? (
                  <Loader />
                ) : error ? (
                  <Message variant="danger">{error}</Message>
                ) : (
                  <Form
                    onSubmit={handleSubmit}
                    className="tw-flex tw-flex-col tw-w-full"
                  >
                    <Row>
                      <Col xs={12} sm={4}>
                        <Form.Group
                          controlId="gensetNumber"
                          className="tw-my-1"
                        >
                          <Form.Label>Genset ID</Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Genset ID"
                            name="gensetNumber"
                            onChange={(e) => setGensetNumber(e.target.value)}
                            value={gensetNumber}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      {/* <Col xs={12} sm={4}>
                        <Form.Group
                          controlId="getsetStatus"
                          className="tw-my-1"
                        >
                          <Form.Label>Genset Status</Form.Label>
                          <Form.Control
                            type="text"
                            name="getsetStatus"
                            placeholder="1 = ON & 0 = OFF"
                            value={getsetStatus}
                            onChange={(e) => setGetsetStatus(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col> */}
                      <Col xs={12} sm={4}>
                        <Form.Group
                          controlId="totalRunningHours"
                          className="tw-my-1"
                        >
                          <Form.Label>Running Hours</Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Running Hours"
                            disabled
                            name="totalRunningHours"
                            value={totalRunningHours}
                            onChange={(e) => {
                              setTotalRunningHours(e.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} sm={4}>
                        <Form.Group controlId="onRelayTime" className="tw-my-1">
                          <Form.Label>Relay ON Time (in sec)</Form.Label>
                          <Form.Control
                            type="number"
                            placeholder={2}
                            min={0}
                            name="onRelayTime"
                            onChange={(e) =>
                              setOnRelayTime(Number(e.target.value))
                            }
                            value={onRelayTime}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={4}>
                        <Form.Group
                          controlId="offRelayTime"
                          className="tw-my-1"
                        >
                          <Form.Label>Relay OFF Time (in sec)</Form.Label>
                          <Form.Control
                            type="number"
                            placeholder={2}
                            min={0}
                            name="offRelayTime"
                            onChange={(e) =>
                              setOffRelayTime(Number(e.target.value))
                            }
                            value={offRelayTime}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={4}>
                        <Form.Group
                          controlId="fuelSensorType"
                          className="tw-my-1"
                        >
                          <Form.Label>Fuel Sensor Type</Form.Label>
                          <Form.Control
                            as="select"
                            name="fuelSensorType"
                            value={fuelSensorType}
                            onChange={(e) =>
                              setFuelSensorType(Number(e.target.value))
                            }
                          >
                            <option value="1">180 Ohm</option>
                            <option value="2">150 Ohm</option>
                            <option value="3">Others</option>
                          </Form.Control>
                          {/* <Form.Control
                            type="number"
                            placeholder="Fuel Sensor Type"
                            name="fuelSensorType"
                            value={fuelSensorType}
                            onChange={(e) => setFuelSensorType(e.target.value)}
                          ></Form.Control> */}
                        </Form.Group>
                      </Col>
                    </Row>
                    {/* <Row className="sm:tw-flex tw-text-center tw-hidden tw-mt-4">
                      <Col xs={12}></Col>
                      <Col>Rated</Col>
                      <Col>Min</Col>
                      <Col>Max</Col>
                    </Row> */}

                    {/* <Row className="tw-mt-2">
                      <Col xs={12}>
                        <Form.Label>Engine Speed (in RPM)</Form.Label>
                      </Col>
                      <Col>
                        <Form.Group
                          controlId="engineSpeedRPM"
                          className="tw-my-1"
                        >
                          <Form.Control
                            type="number"
                            placeholder="Rated"
                            name="engineSpeedRPM"
                            value={engineSpeedRPM}
                            onChange={(e) => setEngineSpeedRPM(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group
                          controlId="engineSpeedRPMMin"
                          className="tw-my-1"
                        >
                          <Form.Control
                            type="number"
                            placeholder="Min"
                            name="engineSpeedRPMMin"
                            value={engineSpeedRPMMin}
                            onChange={(e) =>
                              setEngineSpeedRPMMin(e.target.value)
                            }
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group
                          controlId="engineSpeedRPMMax"
                          className="tw-my-1"
                        >
                          <Form.Control
                            type="number"
                            placeholder="Max"
                            name="engineSpeedRPMMax"
                            value={engineSpeedRPMMax}
                            onChange={(e) =>
                              setEngineSpeedRPMMax(e.target.value)
                            }
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row> */}
                    <Row className="tw-mt-2">
                      <Col xs={12}>
                        <Form.Label>
                          Engine Coolant Temperature (deg)
                        </Form.Label>
                      </Col>
                      <Col>
                        <Form.Group
                          controlId="engineCoolantTempMax"
                          className="tw-my-1"
                        >
                          <Form.Control
                            type="number"
                            placeholder="Max"
                            name="engineCoolantTempMax"
                            value={engineCoolantTempMax}
                            onChange={(e) =>
                              setEngineCoolantTempMax(e.target.value)
                            }
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col>
                        {/* <Form.Group
                          controlId="engineCoolantTemp"
                          className="tw-my-1"
                        >
                          <Form.Control
                            type="number"
                            placeholder="Rated"
                            name="engineCoolantTemp"
                            value={engineCoolantTemp}
                            onChange={(e) =>
                              setEngineCoolantTemp(e.target.value)
                            }
                          ></Form.Control>
                        </Form.Group> */}
                      </Col>
                      <Col>
                        {/* <Form.Group
                          controlId="engineCoolantTempMin"
                          className="tw-my-1"
                        >
                          <Form.Control
                            type="number"
                            placeholder="Min"
                            name="engineCoolantTempMin"
                            value={engineCoolantTempMin}
                            onChange={(e) =>
                              setEngineCoolantTempMin(e.target.value)
                            }
                          ></Form.Control>
                        </Form.Group> */}
                      </Col>
                     
                    </Row>
                    {/* <Row className="tw-mt-2">
                      <Col xs={12}>
                        <Form.Label>Engine Oil Pressure (psi)</Form.Label>
                      </Col>
                      <Col>
                        <Form.Group
                          controlId="engineOilPressure"
                          className="tw-my-1"
                        >
                          <Form.Control
                            type="number"
                            placeholder="Rated"
                            name="engineOilPressure"
                            value={engineOilPressure}
                            onChange={(e) =>
                              setEngineOilPressure(e.target.value)
                            }
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group
                          controlId="engineOilPressureMin"
                          className="tw-my-1"
                        >
                          <Form.Control
                            type="number"
                            placeholder="Min"
                            name="engineOilPressureMin"
                            value={engineOilPressureMin}
                            onChange={(e) =>
                              setEngineOilPressureMin(e.target.value)
                            }
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group
                          controlId="engineOilPressureMax"
                          className="tw-my-1"
                        >
                          <Form.Control
                            type="number"
                            placeholder="Max"
                            name="engineOilPressureMax"
                            value={engineOilPressureMax}
                            onChange={(e) =>
                              setEngineOilPressureMax(e.target.value)
                            }
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row> */}
                    {/* <Row className="tw-mt-2">
                      <Col xs={12}>
                        <Form.Label>Oil Temperature (deg)</Form.Label>
                      </Col>
                      <Col>
                        <Form.Group controlId="oilTemp" className="tw-my-1">
                          <Form.Control
                            type="number"
                            placeholder="Rated"
                            name="oilTemp"
                            value={oilTemp}
                            onChange={(e) => setOilTemp(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId="oilTempMin" className="tw-my-1">
                          <Form.Control
                            type="number"
                            placeholder="Min"
                            name="oilTempMin"
                            value={oilTempMin}
                            onChange={(e) => setOilTempMin(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId="oilTempMax" className="tw-my-1">
                          <Form.Control
                            type="number"
                            placeholder="Max"
                            name="oilTempMax"
                            value={oilTempMax}
                            onChange={(e) => setOilTempMax(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row> */}
                    <Row className="tw-mt-2">
                      <Col xs={12}>
                        <Form.Label>Power Factor</Form.Label>
                      </Col>
                      <Col>
                        <Form.Group
                          controlId="powerFactorMin"
                          className="tw-my-1"
                        >
                          <Form.Control
                            type="number"
                            placeholder="Min"
                            name="powerFactorMin"
                            value={powerFactorMin}
                            onChange={(e) => setPowerFactorMin(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col>
                        {/* <Form.Group controlId="powerFactor" className="tw-my-1">
                          <Form.Control
                            type="number"
                            placeholder="Rated"
                            name="powerFactor"
                            value={powerFactor}
                            onChange={(e) => setPowerFactor(e.target.value)}
                          ></Form.Control>
                        </Form.Group> */}
                      </Col>
                     
                      <Col>
                        {/* <Form.Group
                          controlId="powerFactorMax"
                          className="tw-my-1"
                        >
                          <Form.Control
                            type="number"
                            placeholder="Max"
                            name="powerFactorMax"
                            value={powerFactorMax}
                            onChange={(e) => setPowerFactorMax(e.target.value)}
                          ></Form.Control>
                        </Form.Group> */}
                      </Col>
                    </Row>
                    {/* <Row className="tw-mt-2">
                      <Col xs={12}>
                        <Form.Label>Power (kWh)</Form.Label>
                      </Col>
                      <Col>
                        <Form.Group controlId="powerKWMax" className="tw-my-1">
                          <Form.Control
                            type="number"
                            placeholder="Max"
                            name="powerKWMax"
                            value={powerKWMax}
                            onChange={(e) => setPowerKWMax(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId="powerKWMin" className="tw-my-1">
                          <Form.Control
                            type="number"
                            placeholder="Min"
                            name="powerKWMin"
                            value={powerKWMin}
                            onChange={(e) => setPowerKWMin(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                     
                      <Col>
                        <Form.Group controlId="powerKW" className="tw-my-1">
                          <Form.Control
                            type="number"
                            placeholder="Rated"
                            name="powerKW"
                            value={powerKW}
                            onChange={(e) => setPowerKW(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row> */}
                    <Row className="tw-mt-2">
                      <Col xs={12}>
                        <Form.Label>Active Power (kW)</Form.Label>
                      </Col>
                      <Col>
                        <Form.Group controlId="kwhMax" className="tw-my-1">
                          <Form.Control
                            type="number"
                            placeholder="Max"
                            name="kwhMax"
                            value={kwhMax}
                            onChange={(e) => setKwhMax(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col>
                        {/* <Form.Group controlId="kwh" className="tw-my-1">
                          <Form.Control
                            type="number"
                            placeholder="Rated"
                            name="kwh"
                            value={kwh}
                            onChange={(e) => setKwh(e.target.value)}
                          ></Form.Control>
                        </Form.Group> */}
                      </Col>
                      <Col>
                        {/* <Form.Group controlId="kwhMin" className="tw-my-1">
                          <Form.Control
                            type="number"
                            placeholder="Min"
                            name="kwhMin"
                            value={kwhMin}
                            onChange={(e) => setKwhMin(e.target.value)}
                          ></Form.Control>
                        </Form.Group> */}
                      </Col>
                    
                    </Row>
                    <Row className="tw-mt-2">
                      <Col xs={12}>
                        <Form.Label>Battery Voltage (V)</Form.Label>
                      </Col>
                      <Col>
                        <Form.Group
                          controlId="batteryVoltageMin"
                          className="tw-my-1"
                        >
                          <Form.Control
                            type="number"
                            placeholder="Min"
                            name="batteryVoltageMin"
                            value={batteryVoltageMin}
                            onChange={(e) =>
                              setBatteryVoltageMin(e.target.value)
                            }
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col>
                        {/* <Form.Group
                          controlId="batteryVoltage"
                          className="tw-my-1"
                        >
                          <Form.Control
                            type="number"
                            placeholder="Rated"
                            name="batteryVoltage"
                            value={batteryVoltage}
                            onChange={(e) => setBatteryVoltage(e.target.value)}
                          ></Form.Control>
                        </Form.Group> */}
                      </Col>
                      
                      <Col>
                        {/* <Form.Group
                          controlId="batteryVoltageMax"
                          className="tw-my-1"
                        >
                          <Form.Control
                            type="number"
                            placeholder="Max"
                            name="batteryVoltageMax"
                            value={batteryVoltageMax}
                            onChange={(e) =>
                              setBatteryVoltageMax(e.target.value)
                            }
                          ></Form.Control>
                        </Form.Group> */}
                      </Col>
                    </Row>
                    <Row className="tw-mt-2">
                      <Col xs={12}>
                        <Form.Label>Fuel Level (%)</Form.Label>
                      </Col>
                      <Col>
                        <Form.Group
                          controlId="fuelLevelMin"
                          className="tw-my-1"
                        >
                          <Form.Control
                            type="number"
                            placeholder="Min"
                            name="fuelLevelMin"
                            value={fuelLevelMin}
                            onChange={(e) => setFuelLevelMin(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col>
                        {/* <Form.Group controlId="fuelLevel" className="tw-my-1">
                          <Form.Control
                            type="number"
                            placeholder="Rated"
                            name="fuelLevel"
                            value={fuelLevel}
                            onChange={(e) => setFuelLevel(e.target.value)}
                          ></Form.Control>
                        </Form.Group> */}
                      </Col>
                   
                      <Col>
                        {/* <Form.Group
                          controlId="fuelLevelMax"
                          className="tw-my-1"
                        >
                          <Form.Control
                            type="number"
                            placeholder="Max"
                            name="fuelLevelMax"
                            value={fuelLevelMax}
                            onChange={(e) => setFuelLevelMax(e.target.value)}
                          ></Form.Control>
                        </Form.Group> */}
                      </Col>
                    </Row>
                    <Row className="tw-mt-2">
                      <Col xs={12}>
                        <Form.Label>Frequency (Hz)</Form.Label>
                      </Col>
                    
                      <Col>
                        <Form.Group
                          controlId="frequencyMin"
                          className="tw-my-1"
                        >
                          <Form.Control
                            type="number"
                            placeholder="Min"
                            name="frequencyMin"
                            value={frequencyMin}
                            onChange={(e) => setFrequencyMin(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group
                          controlId="frequencyMax"
                          className="tw-my-1"
                        >
                          <Form.Control
                            type="number"
                            placeholder="Max"
                            name="frequencyMax"
                            value={frequencyMax}
                            onChange={(e) => setFrequencyMax(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col>
                        {/* <Form.Group controlId="frequency" className="tw-my-1">
                          <Form.Control
                            type="number"
                            placeholder="Rated"
                            name="frequency"
                            value={frequency}
                            onChange={(e) => setFrequency(e.target.value)}
                          ></Form.Control>
                        </Form.Group> */}
                      </Col>
                    </Row>
                    <Row className="tw-mt-2">
                      <Col xs={12}>
                        <Form.Label>AC Voltage (V)</Form.Label>
                      </Col>
                      <Col>
                        <Form.Group controlId="voltageMin" className="tw-my-1">
                          <Form.Control
                            type="number"
                            placeholder="Min"
                            name="voltageMin"
                            value={voltageMin}
                            onChange={(e) => setVoltageMin(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId="voltageMax" className="tw-my-1">
                          <Form.Control
                            type="number"
                            placeholder="Max"
                            name="voltageMax"
                            value={voltageMax}
                            onChange={(e) => setVoltageMax(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col>
                        {/* <Form.Group controlId="voltage" className="tw-my-1">
                          <Form.Control
                            type="number"
                            placeholder="Rated"
                            name="voltage"
                            value={voltage}
                            onChange={(e) => setVoltage(e.target.value)}
                          ></Form.Control>
                        </Form.Group> */}
                      </Col>
                  
                    </Row>
                    <Row className="tw-mt-2">
                      <Col xs={12}>
                        <Form.Label>Current (A)</Form.Label>
                      </Col>
                      <Col>
                        <Form.Group controlId="currentMax" className="tw-my-1">
                          <Form.Control
                            type="number"
                            placeholder="Max"
                            name="currentMax"
                            value={currentMax}
                            onChange={(e) => setCurrentMax(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col>
                        {/* <Form.Group controlId="current" className="tw-my-1">
                          <Form.Control
                            type="number"
                            placeholder="Rated"
                            name="current"
                            value={current}
                            onChange={(e) => setCurrent(e.target.value)}
                          ></Form.Control>
                        </Form.Group> */}
                      </Col>
                      <Col>
                        {/* <Form.Group controlId="currentMin" className="tw-my-1">
                          <Form.Control
                            type="number"
                            placeholder="Min"
                            name="currentMin"
                            value={currentMin}
                            onChange={(e) => setCurrentMin(e.target.value)}
                          ></Form.Control>
                        </Form.Group> */}
                      </Col>
                     
                    </Row>
                    <Row className="tw-mt-2">
                      <Col xs={12}>
                        <Form.Label>Service Hours</Form.Label>
                      </Col>
                      <Col>
                        <Form.Group controlId="serviceHours" className="tw-my-1">
                          <Form.Control
                            type="number"
                            placeholder="Service Hours"
                            name="serviceHours"
                            value={serviceHours}
                            onChange={(e) => setServiceHours(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col>
                        {/* <Form.Group controlId="currentMin" className="tw-my-1">
                          <Form.Control
                            type="number"
                            placeholder="Min"
                            name="currentMin"
                            value={currentMin}
                            onChange={(e) => setCurrentMin(e.target.value)}
                          ></Form.Control>
                        </Form.Group> */}
                      </Col>
                      <Col>
                        {/* <Form.Group controlId="currentMin" className="tw-my-1">
                          <Form.Control
                            type="number"
                            placeholder="Min"
                            name="currentMin"
                            value={currentMin}
                            onChange={(e) => setCurrentMin(e.target.value)}
                          ></Form.Control>
                        </Form.Group> */}
                      </Col>
                     
                    </Row>
                    <Row className="tw-mt-2">
                      <Col xs={12}>
                        <Form.Label>Remaining Hours</Form.Label>
                      </Col>
                      <Col>
                        <Form.Group controlId="remainingHours" className="tw-my-1">
                          <Form.Control
                            type="number"
                            disabled
                            placeholder="Remaining Hours"
                            name="remainingHours"
                            value={serviceHours}
                            onChange={(e) => setRemainingHours(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col>
                        {/* <Form.Group controlId="currentMin" className="tw-my-1">
                          <Form.Control
                            type="number"
                            placeholder="Min"
                            name="currentMin"
                            value={currentMin}
                            onChange={(e) => setCurrentMin(e.target.value)}
                          ></Form.Control>
                        </Form.Group> */}
                      </Col>
                      <Col>
                        {/* <Form.Group controlId="currentMin" className="tw-my-1">
                          <Form.Control
                            type="number"
                            placeholder="Min"
                            name="currentMin"
                            value={currentMin}
                            onChange={(e) => setCurrentMin(e.target.value)}
                          ></Form.Control>
                        </Form.Group> */}
                      </Col>
                    </Row>
                    <Row className="tw-mt-2">
                      <Col xs={12}>
                        <Form.Label>Fuel Volume</Form.Label>
                      </Col>
                      <Col>
                        <Form.Group controlId="fuelVolume" className="tw-my-1">
                          <Form.Control
                            type="number"
                            placeholder="Fuel Volume"
                            name="fuelVolume"
                            value={fuelVolume}
                            onChange={(e) => setFuelVolume(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col>
                        {/* <Form.Group controlId="voltage" className="tw-my-1">
                          <Form.Control
                            type="number"
                            placeholder="Rated"
                            name="voltage"
                            value={voltage}
                            onChange={(e) => setVoltage(e.target.value)}
                          ></Form.Control>
                        </Form.Group> */}
                      </Col>     
                      <Col>
                        {/* <Form.Group controlId="voltage" className="tw-my-1">
                          <Form.Control
                            type="number"
                            placeholder="Rated"
                            name="voltage"
                            value={voltage}
                            onChange={(e) => setVoltage(e.target.value)}
                          ></Form.Control>
                        </Form.Group> */}
                      </Col>
                     
                    </Row> 
                    <Form.Group controlId="servicedueDate" className="tw-my-1">
                      <Form.Label>Due Date</Form.Label>
                      <Form.Control
                        type="date"
                        placeholder="Due Date"
                        name="servicedueDate"
                        value={servicedueDate}
                        onChange={(e) => {
                          setServicedueDate(e.target.value)
                        }}
                      ></Form.Control>
                    </Form.Group>
                    <p className="tw-font-nunito tw-my-3 sm:tw-text-3xl tw-text-2xl tw-font-bold tw-text-center">
                      Genset Location
                    </p>
                    <MapContainer
                      center={center}
                      zoom={13}
                      scrollWheelZoom={true}
                      id="map-id"
                    >
                      <TileLayer
                        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      />
                      <Marker
                        draggable={draggable}
                        eventHandlers={eventHandlers}
                        position={position}
                        ref={markerRef}
                      >
                        <Popup minWidth={90}>
                          <span onClick={toggleDraggable}>
                            Latitude: {position.lat} <br />
                            Longitude: {position.lng}
                          </span>
                        </Popup>
                      </Marker>
                    </MapContainer>
                    <br />
                    {position.lng && position.lat && (
                      <Row className="tw-mt-2">
                        <Col>
                          <Form.Group>
                            <Form.Label>Latitude (deg)</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Latitude"
                              name="latitude"
                              value={position.lat}
                              onChange={() => setLatitude(position.lat)}
                            ></Form.Control>
                            {/* {console.log(position.lat)} */}
                          </Form.Group>
                        </Col>
                        <Col>
                          <Form.Group>
                            <Form.Label>Longitude (deg)</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Longitude"
                              name="longitude"
                              value={position.lng}
                              onChange={() => setLongitude(position.lng)}
                            ></Form.Control>
                            {/* {console.log(position.lng)} */}
                          </Form.Group>
                        </Col>
                      </Row>
                    )}
                    <br />
                    <Button
                      type="submit"
                      className="tw-my-4 tw-mb-8 tw-px-28 tw-block tw-mx-auto tw-transition tw-duration-700 tw-ease-in-out tw-transform hover:-tw-translate-y-1 hover:tw-scale-110 myButton"
                    >
                      Create
                    </Button>
                  </Form>
                )}
              </Col>
            </Row>
          </div>
        </FormContainer>
      </div>
    </>
  );
};

export default ProductCreateScreen;
